export default function GeneralIcon(props: { fill?: string }) {
  return (
    <svg
      width="23"
      height="22"
      viewBox="0 0 23 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.8472 11.6483C21.7556 11.6488 21.6648 11.6323 21.58 11.5999C21.4952 11.5675 21.418 11.5197 21.353 11.4594L11.4062 2.14359L1.45938 11.4594C1.32622 11.5661 1.15493 11.6219 0.979749 11.6155C0.804566 11.6092 0.638387 11.5412 0.514421 11.4252C0.390455 11.3092 0.317833 11.1537 0.311066 10.9897C0.304299 10.8257 0.363887 10.6654 0.477921 10.5408L10.9189 0.769027C11.0494 0.647694 11.2258 0.57959 11.4097 0.57959C11.5936 0.57959 11.77 0.647694 11.9004 0.769027L22.3414 10.5408C22.4372 10.6323 22.5021 10.7481 22.5279 10.8739C22.5537 10.9996 22.5394 11.1297 22.4866 11.2479C22.4339 11.3661 22.3451 11.4671 22.2314 11.5383C22.1177 11.6095 21.984 11.6478 21.8472 11.6483Z"
        fill={props.fill ?? 'white'}
      />
      <path
        d="M11.4062 4.3455L3.05337 12.189V20.1172C3.05337 20.4627 3.20004 20.7941 3.46112 21.0385C3.7222 21.2828 4.07629 21.4201 4.44551 21.4201H9.31798V14.9055H13.4944V21.4201H18.3669C18.7361 21.4201 19.0902 21.2828 19.3513 21.0385C19.6123 20.7941 19.759 20.4627 19.759 20.1172V12.1434L11.4062 4.3455Z"
        fill={props.fill ?? 'white'}
      />
    </svg>
  )
}
